import BaseQuestion from "./BaseQuestion";

export default class extends BaseQuestion {
    constructor(dto) {
        super(dto);  
    }

    get Selected() {
        let selected;

        if(this.IsAep || this.IsMultipleSelect) { 
            selected = this.AnswerList.filter(e => Boolean(e.Selected));
            return Boolean(selected.length) ? selected.map(e => e.Value) : null;
        }
        else {
            selected = this.AnswerList.find(e => Boolean(e.Selected));
            return Boolean(selected) ? selected.Value : null;
        }
            
    }

    set Selected(key) {
        
        if(this.IsAep || this.IsMultipleSelect) {

            this.AnswerList.forEach(e => {

                for (let k of key) {

                    if(k.Key == e.Value.Key) {
                        e.Selected = true;
                        break;
                    }                        
                    else
                        e.Selected = false;
                };

            });
        }
        else{
            this.AnswerList.forEach(e => { 
                if(key.Key == e.Value.Key)
                    e.Selected = true;
                else
                    e.Selected = null 
            }); 
        }
    }
}